var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columnfun"},[_c('yo',{attrs:{"cta":"Yo!","ownerID":'5d14608021fc550017b988cd',"earthID":'5d14608121fc550017b988ce'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }